<template>
    <main class="reset-password-container">
        <h1>{{translate('reset_password')}}</h1>
        <form method="post"
              action="/reset"
              class="reset-password-form">
            <div class="input-container">
                <input-reset-password :placeholder="translate('new_password')"
                                      data-type="password"
                                      :require=true
                                      :regex="/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])/"
                                      name="new_password"
                                      :error-msg="translate('error_msg_password')"
                                      v-model="primaryPassword">
                </input-reset-password>
            </div>

            <div class="input-container">
                <input-reset-password :placeholder="translate('repeat_password')"
                                      data-type="password"
                                      :require=true
                                      :regex="/[A-Za-z0-9]/"
                                      name="new_password_retype"
                                      :error-msg="translate('error_msg_repeat_password')"
                                      v-model="confirmationPassword"
                                      :isGloballyCorrectPass="passwordMatch">
                </input-reset-password>
            </div>

            <div class="input-container">
              <input-reset-code data-type="number"
                                maxlength="6"
                                name="code"
                                :placeholder="translate('enter_code')"
                                :require=true
                                v-model="resetCode">
              </input-reset-code>
            </div>
            <div class="navi-btns">
                <button @click.prevent.stop="sendReset" class="reset-btn">{{translate("confirm")}}</button>
            </div>
        </form>
    </main>
</template>

<script>
    import InputResetPassword from "../components/password_reminder/InputResetPassword";
    import InputResetCode from "../components/password_reminder/InputResetCode";

    export default {
        name: "ResetPassword",
        components: {InputResetCode, InputResetPassword},
        data() {
            return {
                value: '',
                isIncorrect: false,
                inputData: [],
                primaryPassword: '',
                confirmationPassword: '',
                passwordMatch: false,
                resetCode: ''
            }
        },

        watch: {
            confirmationPassword: function (value) {
                this.passwordMatch = value === this.primaryPassword;
            },
            primaryPassword: function (value) {
                this.passwordMatch = value === this.confirmationPassword;
            }
        },

        methods: {
            sendReset() {
                this.$emit('getValidateData');

                if (this.isSendingDisabled) {

                    console.error('Uzupełnij wszystkie pola');

                    e.preventDefault();

                    return;

                } else {
                    this.send()
                }
            },

            send() {
                this.$apiController.postResetPassword(this.getFormData())
                    .then((res) => {
                        if (res.status === 'success') {
                            this.$router.push({path: '/login'});
                            this.$notifications.add('notification',this.translate('password_successfully_updated'),this.translate('password_reset_success'));
                        } else {
                            this.$notifications.add('warning',this.translate('warning_reset_password'),this.translate(res.message));
                        }
                    });
            },

            isValidationDataValid() {

                if (this.inputData.length > 0) {
                    this.inputData.forEach((item) => {
                    });
                    return !this.inputData.some((item) => item.isIncorrect === true);

                } else {
                    return false;
                }
            },

            getFormData() {
                let form = new FormData();
                for (let key of this.inputData) {
                    form.append(key.inputName, key.value);
                }
                let locale = this.$store.state.activeLang.id;
                form.append('locale', locale);

                let email = this.$route.params.email;

                if(email) {
                    form.append('email', email);
                } else {
                    //TODO: NOTIFICATION FAIL
                }
                return form;
            },

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },
        },

        computed: {
            isSendingDisabled() {

                return (
                    !this.isValidationDataValid()
                );
            }
        },

        mounted() {
            this.$on('validateData', (d) => {

                if (!this.inputData.some(item => item.inputName === d.inputName)) {
                    this.inputData.push(d)

                } else if (this.inputData.some(item => item.inputName === d.inputName)) {

                    this.inputData.forEach((element) => {
                        if (element.inputName === d.inputName) {
                            element.inputName = d.inputName;
                            element.isIncorrect = d.isIncorrect;
                            element.value = d.value ? d.value : '';
                        }
                    })
                }
            });
        },

        beforeDestroy() {
            this.$off('validateData');
        }
    }
</script>

<style scoped>

</style>